import {
    ORDER_BY, ResponseCode
} from "@app/constants/Common";
import { MaxStepCddEmpProcess } from "@pages/dvtjcuv/common/Constant";
import UpdateDVTJCUVPipelineModal from "@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import {
    requestGetEmployerSummary
} from "@pages/dvtjcuv/service/DVTJCUVService";
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

const DVTJCUVEmployerSummaryModal = (props) => {
    const [selectPipeline, setSelectPipeline] = useState({});
    const [overview, setOverview] = useState({});
    const [pipelines, setPipelines] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [processedCddPipelines, setProcessedCddPipelines] = useState([]);
    const [showUpdatePipelineModal, setShowUpdatePipelineModal] = useState(false);
    const [selectProcessedCdd, setSelectProcessedCdd] = useState(false);

    const {employer, employerId, isShow, onSearch, onClose} = props

    const maxStepCddEmpProcessValues = Object.values(MaxStepCddEmpProcess).map(val => val.toLowerCase());

    const displayMaxStepValue = (maxStep) => {
        if (maxStep === null || maxStep === '' || maxStep < 0) {
            return ""
        }
        return Object.values(MaxStepCddEmpProcess)[maxStep]
    }


    const fetchSummaryOverviews = async (empId) => {
        const res = await requestGetEmployerSummary(empId);
        if (res.sts_code === ResponseCode.SUCCESS) {
            setOverview(res.content)
        } else {
            setOverview({})
        }
    }

    const getPipelineStep = (cddEmpProcess) => {
        if (!cddEmpProcess) {
            return 0
        }
        return maxStepCddEmpProcessValues.indexOf(cddEmpProcess.toLowerCase()); // Tìm index

    }

    const createProcessedCddPipelines = (pps) => {
        // Set step number cho từng item
        const tempPipelines = pps.map(item => {
          item.step = getPipelineStep(item.cdd_emp_process);
          return item
        })

        const sortPipelines = tempPipelines.sort((a, b) => {
            return b.step - a.step;
        });

        // Group theo từng cdd_id và tính toán max step
        const cddIds = []
        const outPipelines = []
        sortPipelines.forEach(item => {
            if (!cddIds.includes(item.cdd_id)) {
                item.max_step = displayMaxStepValue(item.step);
                outPipelines.push(item)
                cddIds.push(item.cdd_id)
            }
        })

        return outPipelines
    }

    const fetchPipeLines = async (empId) => {
        const params = {
            search_conditions: {
                employer_id: empId,
                unlimited: true
            },
            sort_columns: {
                created_date_time: ORDER_BY.DESC_UPDATE_DATE
            }
        }

        const res = await requestGetDVTJCUVPipeLineList(params);
        const resContent = res.content
        setPipelines(resContent.pipelines)
        setTotalCount(resContent.totalCount)
        setProcessedCddPipelines(createProcessedCddPipelines(resContent.pipelines))
    }

    useEffect(() => {
        if (employerId) {
            console.log('Loading data for employer: ', employerId)
            fetchSummaryOverviews(employerId);
            fetchPipeLines(employerId);
        }
    },[employerId])

    const onShowEditPipeline = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectPipeline({...item})
        setShowUpdatePipelineModal(true)
    }
    const getPipelineHistoryMode = () => {
        if (selectProcessedCdd) {
            return DVTJCUVPipelineListMode.DVTJCUV_EMPLOYER_SUMMARY_PROCESSED_CDD
        }

        return DVTJCUVPipelineListMode.DVTJCUV_EMPLOYER_SUMMARY_FULL
    }

    const onSelectProcessedCdd = (isSelect) => {
        setSelectProcessedCdd(isSelect);
        // fetchPipeLines(employer.id, isSelect)
    }

    const getUrl = (cddEmpProcesses) => {
        return `/dvtjcuv/list?employerId=${employerId}&&cddEmpProcess=${cddEmpProcesses || ''}&&unlimited=true&&mode=${DVTJCUVPipelineListMode.DVTJCUV_SEARCH_EMP_SUMMARY}`
    }

    return (
        <>
            <Modal show={isShow}
                fullscreen
                onHide={onClose}
                animation={false}>
                <Modal.Header>
                    <Modal.Title>Tổng hợp DVTJCUV của employer</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body style={{overflowY: 'auto'}}>
                    <div className='card card-default'>
                        <div className='card-header'>
                            <h3 className='card-title text-bold w-100'>Overview</h3>
                            <div className={'row mt-2'}>
                                <div className={'mx-2'}>
                                <a href={`/employer/edit/${employerId}`} target="_blank" rel="noopener noreferrer">{employerId}</a>
                                </div>
                                <div className={'mx-2'}>{employer.brief_name}</div>
                                <div className={'mx-2'}>{employer.bd_status}</div>
                                <div className={'mx-2'}>{employer.local_province}</div>
                                <div className={'mx-2'}>{employer.industry}</div>
                                <div className={'mx-2'}>{employer.function}</div>
                                <div className={'mx-2'}>{employer.note_when_send_cv}</div>
                            </div>
                        </div>
                        <div className='card-body'>
                            
                            <div className={'row'}>
                                <p className={'col-sm-12'}>
                                    Step cao nhất: {displayMaxStepValue(overview.max_step)}
                                </p>
                                
                                <a href={getUrl('Official Offer')}
                                    target={'_blank'}
                                    rel="noopener noreferrer"
                                    className={'col-sm-12'}>
                                    Offer: {overview.offer_count}
                                </a>
                                <a href={getUrl('Verbal Offer')}
                                    target={'_blank'}
                                    rel="noopener noreferrer"
                                    className={'col-sm-12'}>
                                    Gần Offer: {overview.near_offer_count}
                                </a>

                                <a href={getUrl('Interviewing;Interviewed (successful);Interviewed (not successful)')}
                                    target={'_blank'}
                                    rel="noopener noreferrer"
                                    className={'col-sm-12'}>
                                    Số ITV: {overview.itv_count}
                                </a>
                                <a href={getUrl('') + '&&feedback=true'}
                                    target={'_blank'}
                                    rel="noopener noreferrer"
                                    className={'col-sm-12'}>
                                    Feedback: {overview.feedback_count}
                                </a>
                                <a href={getUrl("Cdd's CV sent")}
                                    target={'_blank'}
                                    rel="noopener noreferrer"
                                    className={'col-sm-12'}>
                                    Số CV sent: {overview.cv_sent_count}
                                </a>
                                <a href={getUrl("Brief sent")}
                                    target={'_blank'}
                                    rel="noopener noreferrer"
                                    className={'col-sm-12'}>
                                    Số Brief Sent: {overview.brief_sent_count}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={'card card-default'}>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>
                                Pipeline History ({totalCount})
                            </h3>
                            <div className='card-tools'>
                                <div className='input-group'>
                                    <label>Cdd đã được process</label>
                                    <input type="checkbox"
                                           className="ml-3" name={'only_user_input'}
                                           style={{width: 20, height: 20}}
                                           value={selectProcessedCdd}
                                           checked={selectProcessedCdd}
                                           onChange={() => {
                                               onSelectProcessedCdd(!selectProcessedCdd)
                                           }}/>
                                </div>
                            </div>
                        </div>
                        <div className='card-body'>
                            <DVTJCUVPipelineTableList
                                pipeLines={selectProcessedCdd ? processedCddPipelines : pipelines}
                                mode={getPipelineHistoryMode()}
                                // hideColumns={hideColumns}
                                // showBtnAddPipelineOnRefereeInput={showBtnAddPipelineOnRefereeInput}
                                // onSort={onSort}
                                // sortColumn={searchInput.sort_columns}
                                onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                                // onClose={(reload) => onCloseUpdatePipeLine(reload)}
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {showUpdatePipelineModal &&
                <UpdateDVTJCUVPipelineModal isShow={showUpdatePipelineModal}
                                            pipeLineInfo={selectPipeline}
                                            onClose={(reload) => setShowUpdatePipelineModal(false)}
                />
            }
        </>
    )
}

export default DVTJCUVEmployerSummaryModal;
